import { render } from "./propertiesRow.vue?vue&type=template&id=2a1f1c51"
import script from "./propertiesRow.vue?vue&type=script&lang=js"
export * from "./propertiesRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__